import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import {
  postMessage,
  sendEmailNotification,
  fetchMessages,
} from '../../store/actions/Messages';
import { selectMessages } from '../../store/selectors/Messages';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { upload } from '../../helpers/upLoadHelper';
import Loader from '../../components/Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { fetchSuiteCounts } from '../../store/actions/suites';
import { PATHS } from '../../common/constants';
import { Messages } from '../../components/Messages/Messages';

class SuiteMessages extends Component {
  componentDidMount() {
    let data = {
      ReferenceId: this.props.suite.id,
      ReferenceType: 'Suite',
    };
    this.props.onFetchMessages(data);
  }

  onPostMessage = async (chat) => {
    const { suite } = this.props;
    let imageUrl = null;

    if (chat.image && chat.image.length > 0) {
      imageUrl = await upload(chat.image[0]);
    }

    let fileName = imageUrl ? imageUrl.split('.com/') : '';

    let sentTo =
      this.props.user.roles[0].role.name === 'Property Developer'
        ? suite.homeOwners && suite.homeOwners.id
          ? suite.homeOwners.id
          : 'No Home Owner'
        : this.props.user.roles[0].role.name === 'Home Owner' ||
            this.props.user.roles[0].role.name === 'Admin'
          ? this.props.property.propertyManager &&
            this.props.property.propertyManager.id
            ? this.props.property.propertyManager.id
            : null
          : null;
    if (
      sentTo === 'No Home Owner' ||
      sentTo === '00000000-0000-0000-0000-000000000000'
    ) {
      window.confirm(
        'There is no homeowner associated to this suite. Can not send a message now.'
      );
    } else {
      let data = {
        SentBy: this.props.user.id,
        SentTo: sentTo,
        ReferenceId: this.props.suite.id,
        ReferenceType: 'Suite',
        Message: chat.message,
        FileName: fileName[1],
        FileURL: imageUrl,
        ActionUrl:
          'app/suites/' + suite.propertyId + '&' + suite.id + '/activeTab=4',
      };

      await this.props.postMessage(data);
      this.props.onFetchSuiteCounts(
        this.props.suite.id,
        this.props.user.roles[0].role.name
      );
    }
  };

  onSendEmailNotification = (data) => {
    const { suite, property, url, history } = this.props;
    let chatId = suite.number;
    chatId = chatId?.replace(/\s/g, '') || '';
    let name = data.sentByName;
    name = name.replace(/\s/g, '');

    const path = {
      pathname: PATHS.VIDEO_CHAT,
      state: {
        chatId: 'channel' + chatId,
        sentByName: data.sentByName,
        sentToName: data.sentToName,
        url: url,
        activeTab: 3,
      },
    };

    let params = {
      SentBy: data.sentTo,
      SentTo: data.sentBy,
      ChannelName: 'channel' + chatId,
      ActionUrl: 'app/videoChat/chatId=channel' + chatId + '/' + name,
      PropertyName: property?.name,
      SuiteName: suite?.number,
    };

    this.props.sendEmailNotification(params, path, history);
  };

  render() {
    const { messages, suite, loader, inboxLoader } = this.props;
    let chatId = suite.number;
    chatId = chatId.replace(/\s/g, '');
    return loader ? (
      <Loader />
    ) : (
      <>
        {inboxLoader && <Loader center={true} />}
        <Messages
          breadcrumb={'1231231234'}
          ticketId={chatId}
          messages={messages}
          url={this.props.url}
          onPostMessage={(data) => this.onPostMessage(data)}
          onSendEmailNotification={(data) => this.onSendEmailNotification(data)}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  messages: selectMessages(state),
  loader: selectFormLoader(state),
  inboxLoader: state.inbox?.inboxListLoader || false,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postMessage,
      sendEmailNotification,
      onFetchSuiteCounts: fetchSuiteCounts,
      onFetchMessages: fetchMessages,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SuiteMessages);
